import { render } from "./TheSeries.vue?vue&type=template&id=902a4420&scoped=true"
import script from "./TheSeries.vue?vue&type=script&lang=js"
export * from "./TheSeries.vue?vue&type=script&lang=js"

import "./TheSeries.vue?vue&type=style&index=0&id=902a4420&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-902a4420"]])

export default __exports__